import { IconSize as e, IconViewBox as t } from "../types/icon.types.js";
import { cn as n } from "@myparcel-frontend/utils";
import { computed as r, createElementBlock as i, defineComponent as a, normalizeClass as o, openBlock as s, renderSlot as c, unref as l, useAttrs as u } from "vue";
//#region src/IconBase/IconBase.vue?vue&type=script&setup=true&lang.ts
var d = [
	"aria-label",
	"height",
	"role",
	"viewBox",
	"width"
], f = /*@__PURE__*/ a({
	__name: "IconBase",
	props: {
		width: { default: void 0 },
		height: { default: void 0 },
		viewbox: { default: void 0 },
		size: { default: e.Normal },
		ariaLabel: { default: void 0 }
	},
	setup(a) {
		let f = u(), p = a, m = Object.entries(e).find(([, e]) => e === p.size)[0], h = r(() => String(p.height ?? e[m])), g = r(() => String(p.width ?? e[m])), _ = r(() => String(p.viewbox ?? t[m])), v = r(() => p.ariaLabel ? "img" : "presentation");
		return (e, t) => (s(), i("svg", {
			"aria-label": a.ariaLabel,
			class: o(l(n)("align-baseline inline-block overflow-visible", l(f).class)),
			height: h.value,
			role: v.value,
			viewBox: _.value,
			width: g.value,
			xmlns: "http://www.w3.org/2000/svg"
		}, [c(e.$slots, "default")], 10, d));
	}
});
//#endregion
export { f as default };
